const ReviewsOn = () => {
  return (
    <div className="md:bg-white bg-[#F5F5F5]">
      <div className="container py-[48px]">
        <div className="flex flex-col items-center gap-[48px]">
          <p className="text-[16px] font-[400] leading-[24px] max-w-[635px] text-center">
            Instead of making promises, we provide proof. Read and watch their testimonials to have complete confidence in choosing us as your
            partner.
          </p>
          <div className="w-full flex flex-wrap justify-between items-center gap-[10px]">
            <a href="https://clutch.co/profile/weprodigi-agency#reviews" target="_blank">
              <img src="/images/seo/logos/clutch.svg" alt="clutch" className="md:h-[54px] h-[22px]" />
            </a>
            <a
              href="https://www.google.com/maps/place/Prodigi/@40.1997698,44.5105341,17z/data=!4m8!3m7!1s0x406aa3e369ae5ccd:0x601e8f09360c508f!8m2!3d40.1996844!4d44.510567!9m1!1b1!16s%2Fg%2F11gxnv_hmx?entry=ttu"
              target="_blank"
            >
              <img src="/images/seo/logos/google.svg" alt="google" className="md:h-[54px] h-[22px]" />
            </a>
            <a href="https://www.facebook.com/weprodigi/reviews/" target="_blank">
              <img src="/images/seo/logos/facebook.svg" alt="facebook" className="md:h-[54px] h-[22px]" />
            </a>
            <a href="https://www.goodfirms.co/company/weprodigi-marketing-agency" target="_blank">
              <img src="/images/goodFirms.svg" alt="goodfirms" className="md:h-[40px] h-[12px]" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsOn;
